var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBallotEpb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "256px",
    width: "256px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M383.851,264.917c-0.853-5.141-5.312-8.917-10.517-8.917H352c-5.888,0-10.667,4.779-10.667,10.667v27.243 c0,3.797,2.027,7.296,5.312,9.216c10.048,5.845,16.021,16.128,16.021,27.541c0,17.643-14.357,32-32,32h-256 c-17.643,0-32-14.357-32-32c0-11.392,5.995-21.696,16.021-27.541c3.285-1.92,5.312-5.419,5.312-9.216v-27.243 C64,260.779,59.221,256,53.333,256H32c-5.227,0-9.664,3.776-10.517,8.917L1.643,384h402.069L383.851,264.917z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.667,341.333h256c5.888,0,10.667-4.779,10.667-10.667S336.555,320,330.667,320H320v-61.355 c0-3.755-1.984-7.253-5.227-9.173c-3.243-1.941-7.253-2.005-10.539-0.213c-23.019,12.523-49.899,7.68-67.115-9.557 c-19.115-19.115-22.101-49.301-7.339-71.424l32.491-44.672c2.368-3.243,2.688-7.531,0.896-11.115 c-1.813-3.563-5.504-5.824-9.515-5.824H96c-5.888,0-10.667,4.779-10.667,10.667V320H74.667C68.779,320,64,324.779,64,330.667 S68.779,341.333,74.667,341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.333,0c-25.109,0-57.024,16.107-66.475,21.205L298.667,0.363c-19.136,0-65.323,1.237-80.299,12.267L133.035,65.6 c-4.053,2.517-5.931,7.403-4.629,11.989c1.323,4.587,5.504,7.744,10.261,7.744h96c0.853,0,1.685-0.107,2.517-0.299l14.293-3.52 C270.997,78.656,288,94.016,288,113.195c0,7.403-2.304,14.485-6.677,20.459l-33.557,46.101 c-9.365,14.037-7.509,32.896,4.437,44.843c6.699,6.699,15.637,10.411,25.131,10.411c9.493,0,18.411-3.691,25.131-10.411 l54.08-54.08c20.203-1.131,38.677-9.856,52.395-23.957c18.923,17.557,79.552,23.104,91.563,24.043 c0.277,0.064,0.555,0.064,0.832,0.064c2.667,0,5.269-1.003,7.232-2.837c2.197-2.027,3.435-4.864,3.435-7.829V10.667 C512,4.779,507.221,0,501.333,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,501.333C0,507.221,4.779,512,10.667,512h384c5.888,0,10.667-4.779,10.667-10.667v-96H0V501.333z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallotEpb);
export default __webpack_public_path__ + "static/media/ballotEpb.746c28d5ef11ea5497ab25aa5a73ce9a.svg";
export { ForwardRef as ReactComponent };